import React from "react";
import { Blog } from "pages/rootpage/Blog";
import { Vacancies } from "pages/rootpage/Vacancies";
import { Contact } from "pages/rootpage/Contact";
import { Login } from "pages/Auth/Login";
import { Team } from "pages/rootpage/Team";

import {
  BECOME_HOST_ROUTE,
  BLOG_ROUTE,
  VACANCIES_ROUTE,
  FAQ_ROUTE,
  CONTACT_ROUTE,
  FIND_ROOM_ROUTE,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  HOME_ROUTE,
  STUDENT_PROFILE_VIEW_ROUTE,
  STUDENT_PROFILE_EDIT_FIRST_ROUTE,
  ROOM_INFO_ROUTE,
  STUDENT_MATCHES_ROUTE,
  HOST_PROFILE_VIEW_ROUTE,
  HOST_PROFILE_EDIT_FIRST_ROUTE,
  HOST_ROOMS_ROUTE,
  HOST_TENANTS_ROUTE,
  STUDENT_PROFILE_EDIT_ROUTE,
  HOST_PROFILE_EDIT_ROUTE,
  CHANGE_PASSWORD,
  PRIVACY_ROUTE,
  COOKIES_ROUTE,
  CONTACT_DETAILS_ROUTE,
  TEAM_ROUTE,
  PRESS_ROUTE,
  MISSION_ROUTE,
  PARTNERS_ROUTE,
  STUDENT_ROOMS_ROUTE,
  HOST_CHATS_ROUTE_ID,
  STUDENT_CHATS_ROUTE_ID,
  STUDENT_WIZARD_ROUTE,
  STUDENT_WIZARD_FINISHED_ROUTE,
  HOST_WIZARD_ROUTE,
  HOST_HOUSE_WIZARD_ROUTE,
  HOST_HOUSE_VIEW_ROUTE,
  HOST_HOUSE_EDIT_ROUTE,
  HOST_ROOM_REPUBLISH_ROUTE,
  HOST_PLAN_INTAKE_ROUTE,
  STUDENT_ROUTE_ID
} from "./utils/constants";
import { HostRooms } from "pages/HostRooms";
import { ChangePassword } from "pages/Auth/ChangePassword";
import { DetailedRoomInfo } from "pages/DetailedRoomInfo";
import { MyTenants } from "./pages/MyTenants";
import { PostBlog } from "pages/rootpage/Blog/CardBlog";
import { PostVacancies } from "pages/rootpage/Vacancies/CardVacancies";
import { Faq } from "pages/rootpage/Faq";
import { Privacy } from "pages/rootpage/Privacy";
import { Cookies } from "pages/rootpage/Cookies";
import { HomePage } from "./landing-components/HomePage";
import { UserMainPage } from "./pages/UserMainPage";
import { ContactDetails } from "pages/rootpage/ContactDetails";
import { Press } from "./pages/rootpage/Press";
import { Mission } from "./pages/rootpage/Mission";
import { Partners } from "pages/rootpage/Partners";
import { SearchRoomsMap } from "./pages/SearchRoomsMap";
import { ChatPage } from "./pages/ChatPage";
import styled from "styled-components/macro";
import { People } from "./components/Icons/People";
import { SingleUser } from "./components/Icons/SingleUser";
import { BuildingIcon } from "./components/Icons/Building";
import { KeyIcon } from "./components/Icons/Key";
import { ThumbUpIcon } from "./components/Icons/ThumbUp";
import StudentMatches from "./pages/StudentMatches";
import { WizardStudentPage } from "./pages/Wizard/WizardStudentPage";
import { StudentProfileEdit } from "./pages/ProfileUser/StudentProfileEdit";
import { StudentProfile } from "./pages/ProfileUser/StudentProfile";
import { WizardStepStartSearchPage } from "./components/Wizard/Student/WizardStepStartSearchPage";
import { WizardHostPage } from "./pages/Wizard/WizardHostPage";
import { HostProfile } from "./pages/ProfileUser/HostProfile";
import { HostProfileEdit } from "./pages/ProfileUser/HostProfileEdit";
import { WizardStepPhotos } from "./components/Wizard/House/Steps/WizardStepPhotos";
import { HouseWizard } from "./components/Wizard/House";
import { HouseEditPage } from "./pages/HostRooms/HouseEditPage";
import { HouseRepublishPage } from "./pages/HostRooms/HouseRepublishPage";
import { PlanIntakePage } from "./pages/ProfileUser/PlanIntakePage";
import { Register } from "./pages/Auth/Register";
import { StudentOverview } from "./pages/StudentOverview";

export const RouteIcons = {
  Profile: styled(SingleUser)`
    path {
      stroke: ${(p) => p.theme.colors.textGray};
    }
  `,
  Rooms: styled(BuildingIcon)`
    path {
      stroke: ${(p) => p.theme.colors.textGray};
    }
  `,
  Matching: styled(People)`
    path {
      stroke: ${(p) => p.theme.colors.textGray};
    }
  `,
  Tenants: styled(KeyIcon)`
    path {
      stroke: ${(p) => p.theme.colors.textGray};
    }
  `,
  TipsAndTricks: styled(ThumbUpIcon)`
    path {
      stroke: ${(p) => p.theme.colors.textGray};
    }
  `
};

export interface IRoute {
  readonly path: string;
  component: any;
  keyLocalize: string;
  icon?: React.ReactNode;
}

export type TMenuRoute = Omit<IRoute, "component">;

export const publicRoutes: IRoute[] = [
  {
    path: FIND_ROOM_ROUTE,
    component: <UserMainPage />,
    keyLocalize: "findroom"
  },
  {
    path: BECOME_HOST_ROUTE,
    component: <UserMainPage />,
    keyLocalize: "becomehost"
  },
  {
    path: CONTACT_ROUTE,
    component: <Contact />,
    keyLocalize: "contact"
  },
  {
    path: FAQ_ROUTE,
    component: <Faq />,
    keyLocalize: "faq"
  },
  {
    path: MISSION_ROUTE,
    component: <Mission />,
    keyLocalize: "mission"
  },
  {
    path: BLOG_ROUTE,
    component: <Blog />,
    keyLocalize: "blog"
  }
];

export const publicRoutesHospi: IRoute[] = [
  { path: LOGIN_ROUTE, component: <Login />, keyLocalize: "login" },
  { path: REGISTER_ROUTE, component: <Register />, keyLocalize: "register" },
  {
    path: HOME_ROUTE,
    component: <HomePage />,
    keyLocalize: "register"
  },
  {
    path: BLOG_ROUTE + "/:id",
    component: <PostBlog />,
    keyLocalize: "blog"
  },
  {
    path: TEAM_ROUTE,
    component: <Team />,
    keyLocalize: "team"
  },
  {
    path: PARTNERS_ROUTE,
    component: <Partners />,
    keyLocalize: "partners"
  },
  {
    path: PRESS_ROUTE,
    component: <Press />,
    keyLocalize: "press"
  },
  {
    path: MISSION_ROUTE,
    component: <Mission />,
    keyLocalize: "mission"
  },
  {
    path: VACANCIES_ROUTE,
    component: <Vacancies />,
    keyLocalize: "vacancies"
  },
  {
    path: VACANCIES_ROUTE + "/:id",
    component: <PostVacancies />,
    keyLocalize: "vacancies"
  },
  {
    path: PRIVACY_ROUTE,
    component: <Privacy />,
    keyLocalize: "privacy"
  },
  {
    path: COOKIES_ROUTE,
    component: <Cookies />,
    keyLocalize: "cookies"
  },
  {
    path: CONTACT_DETAILS_ROUTE,
    component: <ContactDetails />,
    keyLocalize: "contactdetails"
  }
];

export const studentRoutes: IRoute[] = [
  {
    path: STUDENT_PROFILE_VIEW_ROUTE,
    component: <StudentProfile />,
    keyLocalize: "profile",
    icon: <RouteIcons.Profile />
  },
  {
    path: STUDENT_PROFILE_EDIT_FIRST_ROUTE,
    component: <StudentProfileEdit />,
    keyLocalize: "profile",
    icon: <RouteIcons.Profile />
  },
  {
    path: STUDENT_PROFILE_EDIT_ROUTE,
    component: <StudentProfileEdit canCancel={true} canDelete={true} />,
    keyLocalize: "profile",
    icon: <RouteIcons.Profile />
  },
  {
    path: STUDENT_ROOMS_ROUTE,
    component: <SearchRoomsMap />,
    keyLocalize: "rooms",
    icon: <RouteIcons.Rooms />
  },
  {
    path: ROOM_INFO_ROUTE + "/:id",
    component: <DetailedRoomInfo />,
    keyLocalize: "rooms",
    icon: <RouteIcons.Rooms />
  },
  {
    path: STUDENT_CHATS_ROUTE_ID,
    component: <ChatPage />,
    keyLocalize: "chats",
    icon: <RouteIcons.Matching />
  },
  {
    path: STUDENT_MATCHES_ROUTE,
    component: <StudentMatches />,
    keyLocalize: "stay",
    icon: <RouteIcons.Tenants />
  },
  {
    path: STUDENT_WIZARD_ROUTE,
    component: <WizardStudentPage />,
    keyLocalize: "wizard",
    icon: null
  },
  {
    path: STUDENT_WIZARD_FINISHED_ROUTE,
    component: <WizardStepStartSearchPage />,
    keyLocalize: "wizardSearch",
    icon: null
  },
  { path: CHANGE_PASSWORD, component: <ChangePassword />, keyLocalize: "login" }
];

export const hostRoutes: IRoute[] = [
  {
    path: HOST_PROFILE_VIEW_ROUTE,
    component: <HostProfile />,
    keyLocalize: "profile",
    icon: <RouteIcons.Profile />
  },
  {
    path: HOST_PROFILE_EDIT_FIRST_ROUTE,
    component: <HostProfileEdit />,
    keyLocalize: "profile",
    icon: <RouteIcons.Profile />
  },
  {
    path: HOST_PROFILE_EDIT_ROUTE,
    component: <HostProfileEdit canCancel={true} canDelete={true} />,
    keyLocalize: "profile",
    icon: <RouteIcons.Profile />
  },
  {
    path: HOST_ROOMS_ROUTE,
    component: <HostRooms />,
    keyLocalize: "rooms",
    icon: <RouteIcons.Rooms />
  },
  {
    path: ROOM_INFO_ROUTE + "/:id",
    component: <DetailedRoomInfo />,
    keyLocalize: "rooms",
    icon: <RouteIcons.Rooms />
  },
  {
    path: HOST_CHATS_ROUTE_ID,
    component: <ChatPage />,
    keyLocalize: "chats",
    icon: <RouteIcons.Matching />
  },
  {
    path: HOST_TENANTS_ROUTE,
    component: <MyTenants />,
    keyLocalize: "tenants",
    icon: <RouteIcons.Tenants />
  },
  {
    path: STUDENT_ROUTE_ID,
    component: <StudentOverview />,
    keyLocalize: "",
    icon: null
  },
  {
    path: CHANGE_PASSWORD,
    component: <ChangePassword />,
    keyLocalize: "login"
  },
  {
    path: HOST_WIZARD_ROUTE,
    component: <WizardHostPage />,
    keyLocalize: "wizard",
    icon: null
  },
  {
    path: "/:lng/host-wizard-photos",
    // @ts-ignore
    component: <WizardStepPhotos state={{}} />,
    keyLocalize: "wizard",
    icon: null
  },
  {
    path: HOST_HOUSE_WIZARD_ROUTE,
    component: <HouseWizard />,
    keyLocalize: "houseWizard",
    icon: null
  },
  {
    path: HOST_HOUSE_VIEW_ROUTE,
    component: <HouseEditPage viewonly={true} />,
    keyLocalize: "houseWizard",
    icon: null
  },
  {
    path: HOST_HOUSE_EDIT_ROUTE,
    component: <HouseEditPage viewonly={false} canCancel={true} />,
    keyLocalize: "houseWizard",
    icon: null
  },
  {
    path: HOST_ROOM_REPUBLISH_ROUTE,
    component: <HouseRepublishPage />,
    keyLocalize: "",
    icon: null
  },
  {
    path: HOST_PLAN_INTAKE_ROUTE,
    component: <PlanIntakePage />,
    keyLocalize: "",
    icon: null
  }
];
